import { cn } from "../lib/utils.js";
import { Skeleton } from "./skeleton.js";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/simple-table.tsx
const SimpleTable = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx("table", {
		"data-slot": "simple-table",
		className: cn("disable-table-mobile-overrides tw:w-full tw:caption-bottom tw:border-collapse tw:text-[12px] tw:tabular-nums", className),
		...props
	});
};
const SimpleTableHeader = (props) => {
	return /* @__PURE__ */ jsx("thead", {
		"data-slot": "simple-table-header",
		className: "tw:bg-transparent tw:[&_tr]:border-b tw:[&_tr]:border-stroke",
		...props
	});
};
const SimpleTableBody = (props) => {
	return /* @__PURE__ */ jsx("tbody", {
		"data-slot": "simple-table-body",
		className: "tw:[&_tr:last-child]:border-0",
		...props
	});
};
const SimpleTableFooter = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx("tfoot", {
		"data-slot": "simple-table-footer",
		className: cn("tw:border-t-2 tw:border-stroke tw:font-medium tw:[&>tr]:last:border-b-0", className),
		...props
	});
};
const SimpleTableRow = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx("tr", {
		"data-slot": "simple-table-row",
		className: cn("tw:border-b tw:border-stroke", className),
		...props
	});
};
const SimpleTableHead = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx("th", {
		"data-slot": "simple-table-head",
		className: cn("tw:px-4 tw:py-2 tw:text-left tw:align-middle", "tw:first:pl-0 tw:last:pr-0", "tw:text-[12px] tw:font-semibold tw:uppercase tw:tracking-[0.02em] tw:text-midnight/50", className),
		...props
	});
};
const SimpleTableCell = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx("td", {
		"data-slot": "simple-table-cell",
		className: cn("tw:px-4 tw:py-2.5 tw:align-middle", "tw:first:pl-0 tw:last:pr-0", className),
		...props
	});
};
const SimpleTableCaption = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx("caption", {
		"data-slot": "simple-table-caption",
		className: cn("tw:mt-4 tw:text-sm tw:text-midnight/50", className),
		...props
	});
};
const HEADER_SKELETON_WIDTHS = [
	"tw:w-14",
	"tw:w-16",
	"tw:w-12",
	"tw:w-20"
];
const CELL_SKELETON_WIDTHS = [
	"tw:w-40",
	"tw:w-16",
	"tw:w-28",
	"tw:w-24"
];
const SimpleTableSkeleton = ({ columns = 2, rows = 5, className }) => {
	return /* @__PURE__ */ jsxs(SimpleTable, {
		className,
		"aria-hidden": true,
		children: [/* @__PURE__ */ jsx(SimpleTableHeader, { children: /* @__PURE__ */ jsx(SimpleTableRow, { children: Array.from({ length: columns }, (_, index) => /* @__PURE__ */ jsx(SimpleTableHead, { children: /* @__PURE__ */ jsx(Skeleton, { className: cn("tw:h-3", HEADER_SKELETON_WIDTHS[index % HEADER_SKELETON_WIDTHS.length]) }) }, index)) }) }), /* @__PURE__ */ jsx(SimpleTableBody, { children: Array.from({ length: rows }, (_, rowIndex) => /* @__PURE__ */ jsx(SimpleTableRow, { children: Array.from({ length: columns }, (_, colIndex) => /* @__PURE__ */ jsx(SimpleTableCell, { children: /* @__PURE__ */ jsx(Skeleton, { className: cn("tw:h-4", CELL_SKELETON_WIDTHS[(rowIndex + colIndex) % CELL_SKELETON_WIDTHS.length]) }) }, colIndex)) }, rowIndex)) })]
	});
};
//#endregion
export { SimpleTable, SimpleTableBody, SimpleTableCaption, SimpleTableCell, SimpleTableFooter, SimpleTableHead, SimpleTableHeader, SimpleTableRow, SimpleTableSkeleton };

//# sourceMappingURL=simple-table.js.map